module.exports = __webpack_public_path__ + "static/img/article.9451d7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/article.svg
// module id = 5TDR
// module chunks = 0